export default {
  getHospitalFunctionInformation: '/platform/api/authorizations/getPartAuth', // 功能列表
  getHospitalHomepageConfig: '/platform/api/product/config/json', // 医院首页配置信息
  getHospitalDigitalInformation: '/platform/api/hosDict/dic/c/list', // 字典值
  getHospitalConfigInformation: '/platform/api/frontend_config/partList', // 医院各功能配置信息
  getEssayTable: '/platform/api/article', // 医院文章列表
  getEssayInfo: '/platform/api/article/{0}' // 医院文章详情
};
